"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
var _styledComponents = require("./styled-components");
var _product = _interopRequireDefault(require("./product"));
var _excluded = ["name", "selectedOffer", "onSelectOffer", "products", "css"];
var ProductList = function ProductList(_ref) {
  var name = _ref.name,
    selectedOffer = _ref.selectedOffer,
    onSelectOffer = _ref.onSelectOffer,
    products = _ref.products,
    css = _ref.css,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactComponents.RadioGroup, Object.assign({
    name: name,
    selectedValue: selectedOffer,
    onChange: onSelectOffer
  }, rest), /*#__PURE__*/_react.default.createElement(_styledComponents.Products, {
    size: {
      '@initial': 'mobile',
      '@tablet': 'tablet',
      '@desktop': 'desktop'
    },
    css: css
  }, products.map(function (_ref2) {
    var id = _ref2.id,
      offerItems = _ref2.offerItems,
      titleDetails = _ref2.titleDetails,
      counterOffer = _ref2.counterOffer,
      counterMessage = _ref2.counterMessage;
    return /*#__PURE__*/_react.default.createElement(_styledComponents.ProductItem, {
      key: id
    }, /*#__PURE__*/_react.default.createElement(_product.default, {
      offerItems: offerItems,
      titleDetails: titleDetails,
      counterMessage: counterOffer ? counterMessage : ''
    }));
  })));
};
ProductList.propTypes = {
  selectedOffer: _propTypes.default.string.isRequired,
  onSelectOffer: _propTypes.default.func.isRequired,
  products: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    content: _propTypes.default.element
  })).isRequired,
  name: _propTypes.default.string,
  css: _propTypes.default.shape({})
};
ProductList.defaultProps = {
  name: 'pf-product-list',
  css: {}
};
var _default = exports.default = ProductList;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan-v2/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');